import React, { useState } from 'react'

const WarningTip = (props) => {
  const [isView, setIsView] = useState(true);

  const icon =  require("../../images/diff.svg");

  // 説明文
  const ViewMessage = () =>{
    if(typeof props.description != 'undefined'){
      const texts = props.description.split('¥n').map((value) => {
          return(<>{value}<br/></>)
      })
      return texts
    }else{
      return <></>
    }
  }
    
  return(
    <>
      <div className="felx_center">
        <img src={icon} className="mr5 pointer" onClick={() => setIsView(isView ? false : true)}/>
        {props.children}
      </div>
      { isView && <div className="interview-warning-tip mt5" ><ViewMessage/></div> }
    </>
  )
}
export default WarningTip;